module.exports = __webpack_public_path__ + "img/icono_soluciones_03.d1d4ad8c.png";